import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "card",
  ref: "contentRef"
}
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "d-flex justify-content-between mb-2" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "fw-normal" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*"),
  /*#__PURE__*/_createTextVNode(" Función que desempeña")
], -1)
const _hoisted_5 = { class: "form-group row" }
const _hoisted_6 = { class: "col-sm-6" }
const _hoisted_7 = { class: "col-sm-6" }
const _hoisted_8 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_AddEditFunction = _resolveComponent("AddEditFunction")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titleDialog,
    modelValue: _ctx.isModalVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isModalVisible) = $event)),
    class: "bg-light rounded w-100 w-md-600px w-lg-600px",
    onOpen: _ctx.onOpen,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    "lock-scroll": "",
    draggable: "",
    "destroy-on-close": "",
    top: "2vh",
    width: "600"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isModalVisible = false)),
          text: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancelar")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: _ctx.loading,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Guardar ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createBlock(_component_el_form, {
            ref: "ruleFormRef",
            model: _ctx.form,
            "status-icon": "",
            rules: _ctx.rules,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "idperson",
                label: "Seleccione una persona",
                rules: [{ required: true, message: 'Campo requerido', trigger: ['blur', 'change'] }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.idperson,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.idperson) = $event)),
                    filterable: "",
                    remote: "",
                    "reserve-keyword": "",
                    clearable: "",
                    placeholder: "Ingrese un texto a buscar...",
                    "remote-method": _ctx.remoteMethod,
                    loading: _ctx.loading,
                    class: "w-100"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPeople, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.idperson,
                          label: item.people,
                          value: item.idperson
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "remote-method", "loading"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_el_button, {
                  type: "primary",
                  link: "",
                  onClick: _ctx.openAddFunction
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("agregar")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _createVNode(_component_el_form_item, {
                prop: "idfunction",
                rules: [{ required: true, message: 'Campo requerido', trigger: ['blur', 'change'] }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.form.idfunction,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.idfunction) = $event)),
                    filterable: "",
                    clearable: "",
                    placeholder: "Seleccione",
                    class: "w-100"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listFunctions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: `lr-${item.idfunction}`,
                          label: item.name,
                          value: item.idfunction
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_form_item, {
                    prop: "date_start",
                    label: "Fecha de inicio",
                    rules: [{ required: true, message: 'Campo requerido', trigger: ['blur', 'change'] }]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.form.date_start,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.date_start) = $event)),
                        type: "date",
                        placeholder: "Seleccione",
                        format: "DD/MM/YYYY",
                        "value-format": "YYYY-MM-DD",
                        class: "w-100"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_el_form_item, {
                    prop: "date_end",
                    label: "Fecha de término"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_date_picker, {
                        modelValue: _ctx.form.date_end,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.date_end) = $event)),
                        type: "date",
                        placeholder: "Seleccione",
                        format: "DD/MM/YYYY",
                        "value-format": "YYYY-MM-DD",
                        class: "w-100"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          }, 8, ["model", "rules"])), [
            [_directive_loading, _ctx.loading]
          ])
        ])
      ], 512),
      _createVNode(_component_AddEditFunction, {
        ref: "AddEditFunctionRef",
        onOnResponseFunction: _ctx.onResponseFunction
      }, null, 8, ["onOnResponseFunction"])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onOpen", "onClosed"]))
}